'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import ReactGA from 'react-ga4';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';
import { amplitudeInstance } from '../../config/amplitude';
import AuthContext from '../../context/AuthContext';
import buildRouteUrl from '../../helpers/buildRouteUrl';
import useIntl from '../../hooks/useIntl';
import useModal from '../../hooks/useModal';
import { Link } from '../../i18n/navigation';
import * as fbq from '../../lib/fpixel';
import BrandLogo from '../BrandLogo';
import Search from '../Search';
// import SubscriptionsPlansModal from '../SubscriptionPlansModal';

function Header() {
  const $ = _c(67);
  const pathname = usePathname();
  const isNewsPage = /\/(?:news|noticias)(?:\/|$)/.test(pathname);
  const intl = useIntl();
  const t = useTranslations();
  const auth = useContext(AuthContext);
  let pathnameWithoutLocale;
  if ($[0] !== intl.locale || $[1] !== pathname) {
    pathnameWithoutLocale = pathname.replace(`${intl.locale}`, "");
    if (pathnameWithoutLocale.includes("//")) {
      pathnameWithoutLocale = pathnameWithoutLocale.slice(1);
    }
    $[0] = intl.locale;
    $[1] = pathname;
    $[2] = pathnameWithoutLocale;
  } else {
    pathnameWithoutLocale = $[2];
  }
  let t0;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = buildRouteUrl("/");
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link href={t0} className="mr-2 md:mr-8" prefetch={true}><BrandLogo className="h-[22px] w-[144px]" priority={true} /></Link>;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = isNewsPage ? "page" : undefined;
  const t3 = `no-underline transition-colors hover:text-white ${isNewsPage ? "font-bold text-white" : "text-[#999]"}`;
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <a href="/br/noticias" aria-current={t2} className={t3}>Notícias</a>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = buildRouteUrl("/");
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = `no-underline ${pathnameWithoutLocale === "/" ? "text-white font-bold" : "text-[#666] hover:opacity-[0.5] regular"}`;
  let t7;
  if ($[9] !== t) {
    t7 = t("header.links.home");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <Link href={t5} className={t6} prefetch={false}>{t7}</Link>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== auth.isLoading || $[15] !== auth.isLoggedIn || $[16] !== pathnameWithoutLocale || $[17] !== t) {
    t9 = !auth.isLoading && auth.isLoggedIn && <Link href={buildRouteUrl("/my-progress")} className={`no-underline ${pathnameWithoutLocale === "/my-progress" ? "text-white font-bold" : "text-[#666] hover:opacity-[0.5] regular"}`} prefetch={true}>{t("header.links.my_progress")}</Link>;
    $[14] = auth.isLoading;
    $[15] = auth.isLoggedIn;
    $[16] = pathnameWithoutLocale;
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== auth.isLoading || $[20] !== auth.isLoggedIn || $[21] !== pathnameWithoutLocale || $[22] !== t) {
    t10 = !auth.isLoading && auth.isLoggedIn && <Link href={buildRouteUrl("/my-list")} className={`no-underline ${pathnameWithoutLocale === "/my-list" ? "text-white font-bold" : "text-[#666] hover:opacity-[0.5] regular"}`} prefetch={true}>{t("header.links.my_list")}</Link>;
    $[19] = auth.isLoading;
    $[20] = auth.isLoggedIn;
    $[21] = pathnameWithoutLocale;
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t4 || $[26] !== t8 || $[27] !== t9) {
    t11 = <div className="flex flex-row items-center mr-8">{t1}<div className="hidden md:flex flex-row gap-x-3">{t4}{t8}{t9}{t10}</div></div>;
    $[24] = t10;
    $[25] = t4;
    $[26] = t8;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="hidden md:flex flex-row flex-1 justify-end"><div className="md:w-[80%]"><Search /></div></div>;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== auth || $[31] !== pathname || $[32] !== t) {
    t13 = <div className="flex flex-row items-center ml-0 md:ml-6">{auth.isLoggedIn ? <DropdownMenu.Root><DropdownMenu.Trigger><span className="text-white hover:text-[#666] font-bold">{auth.userData?.name}</span></DropdownMenu.Trigger><DropdownMenu.Portal style={{
          zIndex: 100
        }} className="z-10"><DropdownMenu.Content align="end" sideOffset={5} className="w-48 rounded-lg p-2 shadow-md md:w-56 bg-black z-10"><DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><Link href={buildRouteUrl("/users/me")} className="flex-grow text-white" prefetch={true}>{t("profile.title")}</Link></DropdownMenu.Item><DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><Link href={buildRouteUrl("/settings")} className="flex-grow text-white" prefetch={true}>{t("profile.settings")}</Link></DropdownMenu.Item><DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><span onClick={() => auth.destroySession()} className="flex-grow text-white">{t("profile.logout")}</span></DropdownMenu.Item></DropdownMenu.Content></DropdownMenu.Portal></DropdownMenu.Root> : <Link onClick={() => amplitudeInstance.logEvent("Header Go To Login Button", {
        page_path: pathname
      })} href={buildRouteUrl("/login")} className="md:ml-4 text-white hover:text-gray-200 font-semibold uppercase">Login</Link>}</div>;
    $[30] = auth;
    $[31] = pathname;
    $[32] = t;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t11 || $[35] !== t13) {
    t14 = <div className="flex flex-row justify-between items-center px-4 md:px-10 py-4 w-full h-[64px] min-h-[64px]">{t11}{t12}{t13}</div>;
    $[34] = t11;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  const t15 = isNewsPage ? "page" : undefined;
  const t16 = `no-underline transition-colors hover:text-white ${isNewsPage ? "font-bold text-white" : "text-[#999]"}`;
  let t17;
  if ($[37] !== t15 || $[38] !== t16) {
    t17 = <a href="/br/noticias" aria-current={t15} className={t16}>Notícias</a>;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = buildRouteUrl("/");
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  const t19 = `no-underline ${pathname === "/" ? "text-white font-bold" : "text-[#666] regular"}`;
  let t20;
  if ($[41] !== t) {
    t20 = t("header.links.home");
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t19 || $[44] !== t20) {
    t21 = <Link href={t18} className={t19} prefetch={false}>{t20}</Link>;
    $[43] = t19;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== auth.isLoading || $[47] !== auth.isLoggedIn || $[48] !== pathname || $[49] !== t) {
    t22 = !auth.isLoading && auth.isLoggedIn && <Link href={buildRouteUrl("/my-progress")} className={`no-underline ${pathname === "/my-progress" ? "text-white font-bold" : "text-[#666] regular"}`} prefetch={true}>{t("header.links.my_progress")}</Link>;
    $[46] = auth.isLoading;
    $[47] = auth.isLoggedIn;
    $[48] = pathname;
    $[49] = t;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== auth.isLoading || $[52] !== auth.isLoggedIn || $[53] !== pathname || $[54] !== t) {
    t23 = !auth.isLoading && auth.isLoggedIn && <Link href={buildRouteUrl("/my-list")} className={`no-underline ${pathname === "/my-list" ? "text-white font-bold" : "text-[#666] regular"}`} prefetch={true}>{t("header.links.my_list")}</Link>;
    $[51] = auth.isLoading;
    $[52] = auth.isLoggedIn;
    $[53] = pathname;
    $[54] = t;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== t17 || $[57] !== t21 || $[58] !== t22 || $[59] !== t23) {
    t24 = <div className="flex flex-col items-center mr-8"><div className="flex flex-row gap-x-3">{t17}{t21}{t22}{t23}</div></div>;
    $[56] = t17;
    $[57] = t21;
    $[58] = t22;
    $[59] = t23;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  let t25;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="md:ml-4"><Search /></div>;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== t24) {
    t26 = <div className="flex md:hidden flex-row justify-between items-center px-4 md:px-10 py-4 bg-black w-full h-[56px] min-h-[56px]">{t24}{t25}</div>;
    $[62] = t24;
    $[63] = t26;
  } else {
    t26 = $[63];
  }
  let t27;
  if ($[64] !== t14 || $[65] !== t26) {
    t27 = <><div className="flex flex-col w-screen min-w-full justify-between items-center z-10 fixed bg-black">{t14}{t26}</div></>;
    $[64] = t14;
    $[65] = t26;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  return t27;
}
export default Header;